import { Component, ViewChild, ViewEncapsulation, inject } from "@angular/core";
import { CerrixPromptService } from "@app/shared/services/cerrix-prompt.service";
import { UserModuleRoleRightModel } from "../shared/user-module-roles-model";
import { GenericListConfig } from "@app/shared/models/GenericList/GenericList";
import { GenericListFieldType } from "@app/shared/models/GenericList/GenericListField";
import { injectTranslation } from "@app/shared/i18n/translation-scope";
import { scope } from "@app/user/i18n/scope";
import { GenericListManagerComponent } from "@app/shared/generic-managers/generic-list-manager/generic-list-manager.component";

@Component({
    selector: "right-description",
    templateUrl: "./right-description.component.html",
    styleUrls: ["./right-description.component.scss"],
    encapsulation: ViewEncapsulation.None,
    imports: [GenericListManagerComponent],
})
export class RightDescriptionComponent {
    private _promptService = inject(CerrixPromptService);
    private _translation = injectTranslation(scope);

    @ViewChild("template", { static: true }) template: any;

    tableConfig: GenericListConfig;

    async open(header: string, rights: UserModuleRoleRightModel[]) {
        await this._translation.ready();
        this.createConfig(rights);
        this._promptService
            .prompt({
                maxWidth: "800px",
                maxHeight: "465px",
                data: {
                    title: header,
                    customTemplate: this.template,
                    cancelButton: {
                        text: this._translation.t("rightDescription.closeButton"),
                    },
                    confirmButton: {
                        show: false,
                    },
                },
            })
            .getResult()
            .subscribe(() => {
                this.tableConfig = null;
            });
    }

    private createConfig(rights: UserModuleRoleRightModel[]) {
        this.tableConfig = <GenericListConfig>{
            fields: [
                {
                    prettyName: this._translation.t("rightDescription.screenField"),
                    fieldName: "rightLocation",
                    fieldType: GenericListFieldType.Text,
                    description: this._translation.t("rightDescription.screenDescription"),
                    showDescriptionInTable: true,
                },
                {
                    prettyName: this._translation.t("rightDescription.actionField"),
                    fieldName: "rightAction",
                    fieldType: GenericListFieldType.Text,
                    description: this._translation.t("rightDescription.actionDescription"),
                    showDescriptionInTable: true,
                },
                {
                    prettyName: this._translation.t("rightDescription.restrictionField"),
                    fieldName: "rightRestriction",
                    fieldType: GenericListFieldType.Text,
                    description: this._translation.t("rightDescription.restrictionDescription"),
                    showDescriptionInTable: true,
                },
            ],

            hideHeader: true,
            limitViewTo: 5,
            showToolbarSearch: true,
            data: rights,
        };
    }
}
